import { render } from "./SearchBar.vue?vue&type=template&id=872e672e&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./SearchBar.vue?vue&type=style&index=1&id=872e672e&lang=css"
import "./SearchBar.vue?vue&type=style&index=2&id=872e672e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-872e672e"]])

export default __exports__